import * as React from "react";
import type { SVGProps } from "react";
const SvgIncreasing = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={65}
    fill="none"
    {...props}
  >
    <path
      stroke="#26A3DD"
      strokeLinecap="round"
      strokeWidth={2}
      d="M4.706 63.059h54.588"
    />
    <path
      fill="#26A3DD"
      d="M9.925 42.002c-1.928 0-3.499-1.569-3.499-3.499 0-1.93 1.57-3.5 3.5-3.5a3.502 3.502 0 0 1 3.497 3.5c0 1.93-1.569 3.5-3.498 3.5Zm0-5.457a1.96 1.96 0 0 0-1.957 1.958 1.96 1.96 0 0 0 1.957 1.958 1.96 1.96 0 0 0 1.958-1.958 1.96 1.96 0 0 0-1.957-1.958ZM24.845 30.528c-1.929 0-3.5-1.57-3.5-3.5s1.571-3.499 3.5-3.499a3.502 3.502 0 0 1 3.498 3.5c0 1.93-1.57 3.499-3.498 3.499Zm0-5.457a1.96 1.96 0 0 0-1.958 1.957 1.96 1.96 0 0 0 1.958 1.959 1.96 1.96 0 0 0 1.958-1.958 1.96 1.96 0 0 0-1.958-1.958ZM40.32 18.292c-1.93 0-3.5-1.569-3.5-3.499 0-1.93 1.57-3.5 3.5-3.5a3.502 3.502 0 0 1 3.497 3.5c0 1.93-1.57 3.5-3.498 3.5Zm0-5.457a1.96 1.96 0 0 0-1.959 1.958 1.96 1.96 0 0 0 1.958 1.958 1.96 1.96 0 0 0 1.958-1.958 1.96 1.96 0 0 0-1.958-1.958Z"
    />
    <rect
      width={6.721}
      height={18.956}
      x={7.463}
      y={44.169}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
      rx={1.125}
    />
    <rect
      width={6.721}
      height={48.132}
      x={49.816}
      y={14.993}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
      rx={1.125}
    />
    <rect
      width={6.721}
      height={39.662}
      x={35.699}
      y={23.463}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
      rx={1.125}
    />
    <rect
      width={6.721}
      height={28.368}
      x={21.581}
      y={34.757}
      fill="#D3ECF8"
      stroke="#26A3DD"
      strokeWidth={1.75}
      rx={1.125}
    />
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="m11.827 36.529 5.205-3.94 5.205-3.94m-10.41 7.88 5.205-3.94 5.205-3.94M27.408 24.821l5.205-3.94 5.205-3.94m-10.41 7.88 5.205-3.94 5.205-3.94"
    />
    <path
      fill="#26A3DD"
      d="M55.378 6.998c-1.929 0-3.5-1.569-3.5-3.499 0-1.93 1.571-3.499 3.5-3.499a3.502 3.502 0 0 1 3.498 3.5c0 1.93-1.57 3.498-3.498 3.498Zm0-5.457A1.96 1.96 0 0 0 53.42 3.5a1.96 1.96 0 0 0 1.958 1.958A1.96 1.96 0 0 0 57.336 3.5a1.96 1.96 0 0 0-1.958-1.958Z"
    />
    <path
      stroke="#26A3DD"
      strokeWidth={1.75}
      d="m42.467 13.527 5.205-3.94 5.205-3.94m-10.41 7.88 5.205-3.94 5.205-3.94"
    />
  </svg>
);
export default SvgIncreasing;
